import React from 'react';
import { t } from 'ttag';
import PropTypes from 'prop-types';
import { Button, Heading, Text } from 'components';

function DialogBox({
  children,
  heading,
  isVisible,
  toggleVisible,
  onAccept,
  onCancel,
  showCancel,
}) {
  const handleClick = (action) => {
    if (action === 'cancel' && onCancel) onCancel();
    if (action === 'accept' && onAccept) onAccept();
    toggleVisible(false);
  };

  if (isVisible)
    return (
      <div className="fixed inset-0 z-10 flex items-center justify-center">
        <div
          className="fixed inset-0 z-10 cursor-pointer overflow-hidden bg-black opacity-50"
          role="button"
          tabIndex={0}
          aria-label={t`Close Dialog`}
          onClick={() => handleClick('cancel')}
        />
        <div className="z-20 m-4 max-w-xs space-y-4 bg-white p-4">
          <div className="border-0 border-b border-solid border-gray pb-2">
            <Heading as="h3" noMargin>
              {heading}
            </Heading>
          </div>
          <Text>{children}</Text>
          <div className="flex items-center space-x-4">
            {showCancel && (
              <Button
                variant="tertiary"
                onClick={() => handleClick('cancel')}
                isFullWidth
                size="sm"
              >
                {t`Cancel`}
              </Button>
            )}

            <Button
              variant="primary"
              onClick={() => handleClick('accept')}
              isFullWidth
              size="sm"
            >
              {t`Proceed`}
            </Button>
          </div>
        </div>
      </div>
    );

  return null;
}

DialogBox.propTypes = {
  children: PropTypes.node.isRequired,
  heading: PropTypes.node.isRequired,
  isVisible: PropTypes.bool.isRequired,
  toggleVisible: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  showCancel: PropTypes.bool,
};

DialogBox.defaultProps = {
  onCancel: undefined,
  showCancel: true,
};

export default DialogBox;
